import React from "react";
import {useStateManager, DisabledPrompt} from "bcms-react";
import { FormRow, FormRowView } from "components/shared";
import { UITextInput } from "components/ui";

import { SVGAsset } from "res";

import "./styles.css";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";

/**
 * @function ImportFileExcludeWidget
 * @return {React.Component}
 * @exported true
 * @description The Import File Exclude widget for the ImportFileNewTemplatePage.
 */
export default function ImportFileExcludeWidget(prop) {
        const {data, onDataChange } = useStateManager();
        const numberOfHeaderRows = data.numberOfHeaderRows;
        const numberOfFooterRows = data.numberOfFooterRows;
    return (
        <div className="import-file-exclude-widget">
            <h2>Number of Rows to Exclude</h2>
            <FormRow className="header-footer-row flex-horizontal align-center">
                <FormRowView className="header-row" text={
                    <div className="flex-container flex-horizontal align-center">
                        <p className="label-with-icon">Header (Optional)</p>
                        <SVGAsset id="InfoIcon" />
                    </div>
                }>
                    <UITextInput dataPoint={ `Number_Of_Header_Rows_Input` } value={numberOfHeaderRows} onChange={onDataChange("numberOfHeaderRows")} />
                </FormRowView>
                <FormRowView className="footer-row" text={
                    <div className="flex-container flex-horizontal align-center">
                        <p className="label-with-icon">Footer (Optional)</p>
                        <SVGAsset id="InfoIcon" />
                    </div>
                }>
                    <UITextInput dataPoint={ `Number_Of_Footer_Rows_Input` } value={numberOfFooterRows} onChange={onDataChange("numberOfFooterRows")}/>
                </FormRowView>
            </FormRow>
            <FormRowView className="text-qualifier-row" text={
                <div className="flex-container flex-horizontal align-center">
                    <p className="label-with-icon">Text Qualifier</p>
                    <SVGAsset id="InfoIcon" />
                </div>
            }>
                <DisabledPrompt>
                    <CustomSelect value="none">
                        <CustomSelectItem dataPoint={ `Text_Qualifier_Select_Option_None` } value="none">None</CustomSelectItem>
                    </CustomSelect>
                </DisabledPrompt>
            </FormRowView>
        </div>
    )
}
